import { useNavigate, useLocation } from "react-router-dom";
import { Layers, ShoppingCart, HardHat, ClipboardList } from "lucide-react";
import { cn } from "@/lib/utils";

function HexNutIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <polygon points="12 2 20.5 7 20.5 17 12 22 3.5 17 3.5 7" />
      <circle cx="12" cy="12" r="3.5" />
    </svg>
  );
}

const TABS = [
  { label: "Assets",          route: "/assets",          icon: Layers },
  { label: "Parts",           route: "/parts",           icon: HexNutIcon },
  { label: "Purchase Orders", route: "/purchase-orders", icon: ShoppingCart },
  { label: "MX Work Orders", route: "/maintenance",     icon: HardHat },
  { label: "Prev. Maint.",   route: "/pm-programs",     icon: ClipboardList },
];

export function MxTabBar() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const q = new URLSearchParams(search).get("q") ?? "";

  return (
    <div className="sticky top-16 z-10 flex items-center gap-0.5 border-b px-3 bg-card overflow-x-auto">
      {TABS.map((tab) => {
        const isActive = pathname === tab.route;
        return (
          <button
            key={tab.route}
            onClick={() => navigate(q ? `${tab.route}?q=${encodeURIComponent(q)}` : tab.route)}
            className={cn(
              "flex items-center gap-1.5 px-2.5 py-3 text-sm font-medium border-b-2 transition-colors -mb-px whitespace-nowrap shrink-0",
              isActive
                ? "border-primary text-primary"
                : "border-transparent text-muted-foreground hover:text-foreground hover:border-border"
            )}
          >
            <tab.icon className="h-3.5 w-3.5" />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
